export default __webpack_public_path__ + "static/media/ECWTrackApp.3cf0ec21.webp";